import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, formatText, formatDate, formatCurrency, formatBoolean } from "../SheetLayout";

const GastosFarmacia: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const gastoFarmaciaId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getPharmacyExpense, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getPharmacyExpense(userId, prestacionId, gastoFarmaciaId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Gastos Farmacia"
        icon="activity"
        pills={<>
          <SheetPill label="Medicamento" value={formatText(d.medicamento)} />
          <SheetPill label="Pagado" value={formatBoolean(d.estaPagado)} />
        </>}
      />

      <SheetSection title="Detalle" icon="file-text">
        <SheetGrid>
          <SheetField label="Medicamento"   value={formatText(d.medicamento)} wide />
          <SheetField label="Cantidad"      value={formatText(d.cantidad)} />
          <SheetField label="Médico"        value={formatText(d.medico)} wide />
          <SheetField label="Fecha Gasto"   value={formatDate(d.fechaGasto)} />
          <SheetField label="Fecha Pago"    value={formatDate(d.fechaPago)} />
          <SheetField label="Importe"       value={formatCurrency(d.importe)} />
          <SheetField label="Pagado"        value={formatBoolean(d.estaPagado)} />
          <SheetField label="Excluido"      value={formatBoolean(d.estaExcluido)} />
        </SheetGrid>
      </SheetSection>
    </SheetPage>
  );
};

export default GastosFarmacia;
